/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoLoginRequest model module.
 * @module model/ManagerAccountControllerDtoLoginRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoLoginRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoLoginRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoLoginRequest
     * @param email {String} 
     * @param password {String} 
     */
    constructor(email, password) { 
        
        ManagerAccountControllerDtoLoginRequest.initialize(this, email, password);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email, password) { 
        obj['email'] = email;
        obj['password'] = password;
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoLoginRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoLoginRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoLoginRequest} The populated <code>ManagerAccountControllerDtoLoginRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoLoginRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoLoginRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoLoginRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerAccountControllerDtoLoginRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }

        return true;
    }


}

ManagerAccountControllerDtoLoginRequest.RequiredProperties = ["email", "password"];

/**
 * @member {String} email
 */
ManagerAccountControllerDtoLoginRequest.prototype['email'] = undefined;

/**
 * @member {String} password
 */
ManagerAccountControllerDtoLoginRequest.prototype['password'] = undefined;






export default ManagerAccountControllerDtoLoginRequest;

